import mergeDeepWith from './mergeDeepWith';

export default (object, source, exceptions) => mergeDeepWith(object, source, exceptions);
